var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCovidShield(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "protect_1") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    stroke: "#000000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 40,
    cy: 40,
    r: 38,
    fill: "#ffd500",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 40,
    cy: 40,
    r: 38,
    fill: "none",
    stroke: "#000000"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#fff2b3",
    stroke: "#000000",
    d: "M17.66,24.92C17.66,58,40,65.45,40,65.45S62.34,58,62.34,24.92c0,0-8.14-8.29-22.34-8.29s-22.34,8.29-22.34,8.29"
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#fff2b3",
    x1: 63.95,
    y1: 18.19,
    x2: 63.95,
    y2: 30.25
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#fff2b3",
    x1: 68.21,
    y1: 28.48,
    x2: 59.69,
    y2: 19.96
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#fff2b3",
    x1: 69.97,
    y1: 24.22,
    x2: 63.91,
    y2: 24.22
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#fff2b3",
    x1: 68.21,
    y1: 19.96,
    x2: 63.91,
    y2: 24.25
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000000",
    d: "M33.72,45.42c0,3.89,3.42,5.46,6.45,5.46s6.51-1.57,6.51-5.46S43.24,40,40.23,40s-6.91-1.58-6.91-5.47S37.08,29,40.1,29s6.58,1.55,6.58,5.46M40.17,54.81V25.1"
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#000000",
    x1: 40,
    y1: 16.63,
    x2: 40,
    y2: 19.29
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#000000",
    x1: 40,
    y1: 62.79,
    x2: 40,
    y2: 65.45
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCovidShield);
export default __webpack_public_path__ + "static/media/covid-shield.efe67243.svg";
export { ForwardRef as ReactComponent };